<template>
    <div class="contact-avatar" :class="{ [size]: true }" :style="{ '--background-color': getProfileColor() }">
        <div class="contact-avatar-image" v-if="contact">
            <img ref="image" v-if="getContactAvatar() && !fullname" :src="getContactAvatar()" :alt="'Contact Avatar'" />
            <div v-else>{{ getSortedFullname() }}</div>
        </div>
        <div class="contact-avatar-badge" :class="{ [badgeType]: !!badgeType }" v-if="badge"></div>
    </div>
</template>
<script>
import * as _ from "lodash";
import { mapState } from "vuex";

export default {
    name: "ContactAvatar",
    props: {
        contact: {
            type: Object,
            default: () => ({}),
        },
        fullname: {
            type: String,
            default: null,
        },
        badge: {
            type: Boolean,
            default: false,
        },
        badgeCount: {
            default: 0,
        },
        size: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        invalidImage: false,
    }),
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            liveVisitors: (state) => state.visitor.liveVisitors,
            selectedContact: (state) => state.contact.selectedContact,
            watchingContactIds: (state) => state.chat.watchingContactIds,
        }),
        badgeType: function () {
            const isUnreaded = this.contact.unreadedCount > 0;
            const isVisitorOnline = this.IsVisitorOnline();
            const isDestroyed = this.contact.lastConversation?.status === "destroyed";
            const isWatching = this.watchingContactIds.includes(this.contact._id);
            const isConnectedUser = this.contact.lastConversation?.connectedUser === this.user._id;
            if (isUnreaded) return "unread";
            if (isVisitorOnline) return "visitor-online";
            if (isDestroyed) return "passive";
            if (isWatching) return "observing";
            if (isConnectedUser) return "auto-assign";
            return "passive";
        },
    },
    methods: {
        getSortedFullname() {
            const fullname = this.fullname || this.contact.fullname;
            return (fullname || "")
                .split(/[^A-Z|^a-z|^0-9]/g)
                .map((c) => (parseInt(c) ? c : c[0]))
                .join("")
                .slice(0, 5);
        },
        getContactAvatar() {
            if (this.fullname) return;
            /*if (this.conversation.whatsappNumber) {
                return `${CONFIG.WHATSAPP.avatarAddress}?contactId=${this.conversation.whatsappNumber}&siteId=${
                    this.site._id
                }&token=${getPersistenceData("Admin-Token")}&r=${Math.random() * 1000}`;
            } else  */
            if (this.contact.instagramUserId) {
                return _.get(this.contact, "instagramInfo.profile_pic");
            } else if (this.contact.messengerUserId) {
                return _.get(this.contact, "messengerInfo.profile_pic");
            } else if (this.contact.linkedinUserId) {
                return _.get(this.contact, "linkedinInfo.picture_url");
            } else if (this.contact.telegramUserId) {
                return _.get(this.contact, "telegramInfo.picture_url");
            }
            return null;
        },
        getProfileColor() {
            // let hash = 0;
            // (this.contact?._id || "").split("").forEach((char) => {
            //     hash = char.charCodeAt(0) + ((hash << 4) - hash);
            // });
            // const red = (hash >> 0) & 0xf0;
            // const green = (hash >> 8) & 0xf0;
            // const blue = (hash >> 16) & 0xf0;
            // return `rgb(${red}, ${green > 200 ? 200 : green}, ${blue}, 0.7)`;

            const isAssignedToMe = this.contact?.lastConversation?.users?.includes(this.user._id);
            const isAssignedToAnotherAgent = !isAssignedToMe && (this.contact?.lastConversation?.users?.length > 0 || !!this.contact?.lastConversation?.connectedUser);
            const isClosed = this.contact?.lastConversation?.status === "destroyed";
            const isInQueue = this.contact?.lastConversation?.status === "new";
            const isInChatbot = this.contact?.lastConversation?.status === "chatbot";
            if (isClosed) {
                return "#D3D3D3";
            } else if (isInQueue) {
                return "#9370DB";
            } else if (isAssignedToMe) {
                return "#32CD32";
            } else if (isInChatbot) {
                return "#87CEEB";
            } else if (isAssignedToAnotherAgent) {
                return "#FFA500";
            } else {
                return "#D3D3D3";
            }
        },
        isActive() {
            return this.contact && this.selectedContact?._id === this.contact?._id;
        },
        IsVisitorOnline() {
            return this.contact.platform === "web" ? this.liveVisitors.includes(this.contact._id) : true;
        },
    },
};
</script>
<style lang="scss" scoped>
.contact-avatar {
    width: 70px;
    height: 70px;
    min-width: 70px;
    min-height: 70px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    &.small {
        width: 50px;
        height: 50px;
        min-width: 50px;
        min-height: 50px;

        .contact-avatar-image {
            font-size: 14px;
        }

        .contact-avatar-badge {
            width: 15px;
            height: 15px;
        }
    }

    &.smallest {
        width: 35px;
        height: 35px;
        min-width: 35px;
        min-height: 35px;

        .contact-avatar-image {
            font-size: 14px;
        }

        .contact-avatar-badge {
            width: 8px;
            height: 8px;
        }
    }

    .contact-avatar-image {
        width: 100%;
        height: 100%;
        overflow: hidden;
        border-radius: 1000px;
        background: var(--background-color);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        color: white;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .contact-avatar-badge {
        display: none;
        position: absolute;
        top: 0;
        right: 0;
        width: 20px;
        height: 20px;
        border-radius: 60px;
        background: green;
        //display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
        text-overflow: ellipsis;
        border: 2px solid var(--white);

        &.visitor-online {
            background-color: #22a837;
            color: #ffffff;
        }

        &.visitor-offline {
            background-color: #afafaf;
            color: #ffffff;
        }

        &.unread {
            background-color: #3699ff;
            color: #ffffff;
        }

        &.active {
            background-color: #1bc5bd;
            color: #ffffff;
        }

        &.passive {
            background-color: #afafaf;
            color: #ffffff;
        }

        &.auto-assign {
            background-color: #ffa800;
            color: #ffffff;
        }

        &.observing {
            background-color: #f64e60;
            color: #ffffff;
        }
    }
}
</style>
